import { CircularProgress } from '@mui/material';
import { frameHeight } from 'stylesheet';

import { getCircularProgressSx } from './Loader.style';

type Props = {
  sizeInPx?: number;
  color?: 'inherit' | 'primary';
  position?: 'absolute' | 'static';
};

export const Loader = ({ sizeInPx, color, position }: Props) => {
  const sx = getCircularProgressSx({ position: position ?? 'static' });
  return (
    <CircularProgress sx={sx} size={sizeInPx ?? frameHeight.loader} color={color ?? 'primary'} />
  );
};
